function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import componentMixin from "../mixin";
import componentHelpers from "../helpers";
var componentDef = {
  mixins: [componentMixin],
  template: componentHelpers.inlineTemplate,
  data: function data() {
    return {};
  },
  inject: ['parentNestedFormRuntimeTemplates', 'parentNestedFormRuntimeTemplateDomElements', 'parentNestedForms'],
  methods: {
    addItem: function addItem(key) {
      var templateString = JSON.parse(this.getTemplateElement().querySelector('#prototype-template-for-' + key).dataset[":template"]);
      var regex = /&quot;component_uid&quot;:&quot;(.+?)&quot;/g;
      var staticComponentUidMatches = templateString.matchAll(regex);
      var staticComponentUids = [];

      var _iterator = _createForOfIteratorHelper(staticComponentUidMatches),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var match = _step.value;
          staticComponentUids.push(match[1]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      staticComponentUids.forEach(function (uid) {
        var newUid = Math.floor(Math.random() * 1000000000);
        templateString = templateString.replaceAll(uid, newUid);
      });
      var tmpDomElem = document.createElement('div');
      tmpDomElem.innerHTML = templateString;

      if (this.parentNestedFormRuntimeTemplateDomElements[key] == null) {
        var dom_elem = document.createElement('div');
        dom_elem.innerHTML = templateString;
        var existingItemsCount;

        if (this.parentNestedForms[key] == undefined) {
          existingItemsCount = 0;
        } else {
          existingItemsCount = this.parentNestedForms[key].length;
        }

        dom_elem.querySelector('.matestack-form-fields-for').id = key + "_child_" + existingItemsCount;
        this.parentNestedFormRuntimeTemplateDomElements[key] = dom_elem;
        this.parentNestedFormRuntimeTemplates[key] = this.parentNestedFormRuntimeTemplateDomElements[key].outerHTML;
      } else {
        var dom_elem = document.createElement('div');
        dom_elem.innerHTML = templateString;
        var existingItemsCount = this.parentNestedForms[key].length;
        dom_elem.querySelector('.matestack-form-fields-for').id = key + "_child_" + existingItemsCount;
        this.parentNestedFormRuntimeTemplateDomElements[key].insertAdjacentHTML('beforeend', dom_elem.innerHTML);
        this.parentNestedFormRuntimeTemplates[key] = this.parentNestedFormRuntimeTemplateDomElements[key].outerHTML;
      }
    }
  }
};
export default componentDef;